import React from 'react'
import Layout from '../../Layout'
import AcceptedOrderSupplierPeykContainer from '../../../../Components/OrdersPeykPart/AcceptedOrderSupplierPeykContainer/AcceptedOrderSupplierPeykContainer'

const AcceptedOrderSupplierPeyk = () => {
  return (
    <Layout>
      <AcceptedOrderSupplierPeykContainer/>
    </Layout>
  )
}

export default AcceptedOrderSupplierPeyk